import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import store from '@state/store'
import { i18n } from './i18n'
import design from '@design'

Vue.use(Vuetify)

const opts = {
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    dark: store.getters['auth/darkMode'],
    themes: {
      light: {
        // greyscale
        white: design['global-theme-light-white'],
        offwhite: design['global-theme-light-offwhite'],
        background: design['global-theme-light-bg'],
        input: design['global-theme-light-input'],
        line: design['global-theme-light-line'],
        placehold: design['global-theme-light-placehold'],
        label: design['global-theme-light-label'],
        body: design['global-theme-light-body'],
        ash: design['global-theme-light-ash'],
        offblack: design['global-theme-light-offblack'],
        black: design['global-theme-light-black'],
        // theme
        primary: design['global-theme-light-primary'],
        secondary: design['global-theme-light-secondary'],
        success: design['global-theme-light-success'],
        warning: design['global-theme-light-warning'],
        error: design['global-theme-light-error'],
        accent: design['global-theme-light-accent'],
        info: design['global-theme-light-info'],
        // custom
        tertiary: design['global-theme-light-tertiary'],
        upload: design['global-theme-light-upload'],
      },
      dark: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
}

export default new Vuetify(opts)
